// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__6H5mR","icon":"styles_icon__5fogv","text":"styles_text__EqhzC","image":"styles_image__Wmdar"};